import { render, staticRenderFns } from "./CustomFieldsDetailForm.vue?vue&type=template&id=2058cfd2&scoped=true&"
import script from "./CustomFieldsDetailForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsDetailForm.vue?vue&type=style&index=0&id=2058cfd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058cfd2",
  null
  
)

export default component.exports